module.exports = __webpack_public_path__ + "img/ENTP.1cef5af1.png";